import { Link } from 'react-router-dom';
import { SinceFoundation } from '../SinceFoundation';
import { SloganLine } from '../SloganLine';

export function Footer() {
  return (
    <footer className="bg-[var(--color-background)]">
      <div className="px-6 md:px-10 py-10 md:py-14">
        {/* Slogan */}
        <SloganLine size="sm" />

        {/* Hairline info row */}
        <div className="border-t border-[var(--color-rule)] mt-8 flex flex-wrap gap-x-8 gap-y-2 py-6">
          <Link
            to="/"
            className="font-en uppercase text-xs text-[var(--color-ink-3)] whitespace-nowrap hover:text-white transition-colors"
          >
            WORK
          </Link>
          <Link
            to="/lab"
            className="font-en uppercase text-xs text-[var(--color-ink-3)] whitespace-nowrap hover:text-white transition-colors"
          >
            LAB
          </Link>
          <Link
            to="/about"
            className="font-en uppercase text-xs text-[var(--color-ink-3)] whitespace-nowrap hover:text-white transition-colors"
          >
            ABOUT
          </Link>
          <span className="font-en uppercase text-xs text-[var(--color-ink-3)] whitespace-nowrap">
            BUSAN, KOREA
          </span>
          <span className="font-en uppercase text-xs text-[var(--color-ink-3)] whitespace-nowrap">
            LIGHTIVE.KR
          </span>
          <SinceFoundation variant="compact" />
        </div>

        {/* Bottom: Copyright */}
        <div className="border-t border-[var(--color-rule)] pt-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <span className="font-en font-bold text-[10px] uppercase tracking-widest text-[var(--color-ink-3)]">
            &copy; {new Date().getFullYear()} LIGHTIVE
          </span>
          <span className="font-en font-bold text-[10px] uppercase tracking-widest text-[var(--color-ink-3)]">
            ALL RIGHTS RESERVED
          </span>
        </div>
      </div>
    </footer>
  );
}
